import Tooltip from 'rc-tooltip';
import { Navigate } from 'react-router-dom';

import { routerKeys } from '~shared/router';
import { CheckBox, InputText, Preloader, Svg } from '~shared/ui';

import { DeviceItem } from './DeviceItem';
import { useEditSection } from './use-edit-section.ts';

type Props = {
	sectionId: string;
};

export function SectionEdit({ sectionId }: Props) {
	const {
		pending,
		section,
		devices,
		errors,
		addDevice,
		deleteDevice,
		deviceChangeNumber,
		deviceChangeCode,
		save,
		remove,
		changeTitle,
		changeLat,
		changeLon,
		changeRc,
		changeAllAllowed,
		saving,
	} = useEditSection(sectionId);

	if (pending) return <Preloader />;
	if (errors['loading']) return <Navigate to={routerKeys.page404()} />;

	const handleRemove = () => {
		if (section.id && confirm('Вы уверены?')) {
			remove();
		}
	};

	return (
		<>
			<div className="row">
				<div className="col col--90">
					<InputText
						placeholder="Название участка"
						value={section.title ?? ''}
						onChange={changeTitle}
						error={errors['title']}
					/>
				</div>
			</div>
			<div className="row vcenter">
				<div className="col col--25">
					<InputText
						placeholder="Широта участка"
						value={section.lat ?? ''}
						onChange={changeLat}
						error={errors['lat']}
					/>
				</div>
				<div className="col col--25">
					<InputText
						placeholder="Долгота участка"
						value={section.lon ?? ''}
						onChange={changeLon}
						error={errors['lon']}
					/>
				</div>
				<div className="col col--25">
					<CheckBox label="Склад РЦ" checked={section.is_rc ?? false} onChange={changeRc} />
				</div>
			</div>
			<h3>Устройства</h3>
			<div className="row vcenter">
				{devices.map(device => (
					<DeviceItem
						key={device.key}
						device={device}
						errorNumber={errors[`${device.key}_number`]}
						errorCode={errors[`${device.key}_code`]}
						onChangeNumber={deviceChangeNumber}
						onChangeCode={deviceChangeCode}
						onDelete={deleteDevice}
					/>
				))}
				<Tooltip placement="top" overlay="Добавить устройство">
					<button className="btn add-btn" onClick={addDevice}>
						<Svg name="add" />
					</button>
				</Tooltip>
			</div>
			<h3>Пользователи</h3>
			<div className="row">
				<div className="col col--90">
					<CheckBox checked={section.is_all_allowed} label={'Доступно всем'} onChange={changeAllAllowed} />
				</div>
				{errors['users'] && <div className="col col--30 error">{errors['users']}</div>}
			</div>
			{/* {!section.is_all_allowed && <SectionUsers users={users} onAddUser={addUser} onDelUser={delUser} />} */}
			<div className="row buttons">
				{saving ? (
					<Preloader />
				) : (
					<>
						{section.id && <button onClick={handleRemove}>Удалить</button>}
						<button onClick={save}>Сохранить</button>
					</>
				)}
			</div>
		</>
	);
}
